import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AlchemistAbandoned1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ALCHEMIST_ABANDONED1;
}

export default AlchemistAbandoned1PoiTileEntity;
